import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";

import { Spinner } from "app/NativeComponents/common";

/* Dashboard Route */

import Dashboard from "app/DealMachineCore/components/Dashboard";
import OnboardingComplete from "app/DealMachineCore/components/OnboardingComplete";
import AccountActivity from "app/DealMachineCore/components/AccountActivity";
import MailerCalendar from "app/DealMachineCore/components/MailerCalendar";

import ActivityPropertyList from "app/DealMachineCore/components/ActivityPropertyList";
import VerifyEmail from "app/DealMachineCore/components/VerifyEmail";
import VerifyPhone from "app/DealMachineCore/components/VerifyPhone";

/* Deal Routes */
import PropertyMap from "app/DealMachineCore/components/PropertyMap";
import ManuallyAddProperty from "app/DealMachineCore/components/ManuallyAddProperty";
import PropertyMapOptions from "app/DealMachineCore/components/PropertyMapOptions";
import DefaultLocation from "app/DealMachineCore/components/DefaultLocation";

import EditDealWon from "app/DealMachineCore/components/EditDealWon";

import EditNote from "app/DealMachineCore/components/EditNote";
import MailTimeline from "app/DealMachineCore/components/MailTimeline";

/* Analytic Routes */
import PartnerDashboard from "app/NativeComponents/components/PartnerDashboard";
import EditPaypalEmail from "app/DealMachineCore/components/EditPaypalEmail";
import EditPartnerWebsite from "app/DealMachineCore/components/EditPartnerWebsite";
import AnalyticsFilters from "app/DealMachineCore/components/AnalyticsFilters";

/* Driving Routes */
import Driving from "app/DealMachineCore/components/Driving";
import DrivingRouteFilters from "app/DealMachineCore/components/DrivingRouteFilters";
import RouteProperties from "app/DealMachineCore/components/RouteProperties";

/* List Builder Routes */
import ListDashboard from "app/DealMachineCore/components/ListDashboard";
import BuildList from "app/DealMachineCore/components/BuildList";
import EditList from "app/DealMachineCore/components/EditList";

/* Message Engine Routes */
import MessageDashboard from "app/DealMachineCore/components/MessageDashboard";
import PurchasePhoneNumber from "app/DealMachineCore/components/PurchasePhoneNumber";
import Conversation from "app/DealMachineCore/components/Conversation";
import ConversationLeadInfo from "app/DealMachineCore/components/ConversationLeadInfo";
import MultiSendNumbers from "app/DealMachineCore/components/MultiSendNumbers";
import ManagePhoneNumbers from "app/DealMachineCore/components/ManagePhoneNumbers";
import ConversationSettings from "app/DealMachineCore/components/ConversationSettings";
import ManageSavedReplies from "app/DealMachineCore/components/ManageSavedReplies";

/* Team Routes */
import Team from "app/DealMachineCore/components/Team";
import CollectDealFinders from "app/DealMachineCore/components/CollectDealFinders";

import TrainingVideos from "app/DealMachineCore/components/TrainingVideos";
import OnboardingTrainingVideos from "app/DealMachineCore/components/OnboardingTrainingVideos";

import User from "app/DealMachineCore/components/User";

/* Campaign Routes */
import Campaigns from "app/DealMachineCore/components/Campaigns";
import EditCampaign from "app/DealMachineCore/components/EditCampaign";

/* Template Routes */
import Templates from "app/DealMachineCore/components/Templates";
import EditTemplate from "app/DealMachineCore/components/EditTemplate";

/* Signature Routes */
import Signatures from "app/DealMachineCore/components/Signatures";
import EditSignature from "app/DealMachineCore/components/EditSignature";

/* Settings Routes */
import Settings from "app/DealMachineCore/components/Settings";
import BulkUploadMapping from "app/NativeComponents/components/BulkUploadMapping";

import Account from "app/DealMachineCore/components/Account";
import EditEmail from "app/DealMachineCore/components/EditEmail";
import EditPassword from "app/DealMachineCore/components/EditPassword";
import EditUserInfo from "app/DealMachineCore/components/EditUserInfo";
import CreateCustomPropertyTags from "app/DealMachineCore/components/CreateCustomPropertyTags";
import CustomPropertyTags from "app/DealMachineCore/components/CustomPropertyTags";
import EnginesAndAddons from "app/DealMachineCore/components/EnginesAndAddons";

/* Bilings Routes*/
import BillingDashboard from "app/DealMachineCore/components/BillingDashboard";
import BillingDetails from "app/DealMachineCore/components/BillingDetails";
import CardOnFile from "app/DealMachineCore/components/CardOnFile";

import SellLeads from "app/DealMachineCore/components/SellLeads";
import RetentionCenter from "app/DealMachineCore/components/RetentionCenter";
import CreditReload from "app/DealMachineCore/components/CreditReload";
import PurchaseCredits from "app/DealMachineCore/components/PurchaseCredits";
import Invoices from "app/DealMachineCore/components/Invoices";

import SendingOptions from "app/DealMachineCore/components/SendingOptions";
import Notifications from "app/DealMachineCore/components/Notifications";
import Promo from "app/DealMachineCore/components/Promo";

/* Other Routes */
import Badges from "app/DealMachineCore/components/Badges";
import Share from "app/DealMachineCore/components/Share";
import Canceled from "app/DealMachineCore/components/Canceled";
import TeamRemoved from "app/DealMachineCore/components/TeamRemoved";
import RequestTeam from "app/DealMachineCore/components/RequestTeam";
import RequestedTeam from "app/DealMachineCore/components/RequestedTeam";
import AcceptTerms from "app/DealMachineCore/components/AcceptTerms";
import AcceptAffiliateTerms from "app/DealMachineCore/components/AcceptAffiliateTerms";

import Leads from "app/DealMachineCore/components/Leads";
import LeadFilters from "app/DealMachineCore/components/LeadFilters";
import HighlightProperties from "app/DealMachineCore/components/HighlightProperties";
import EditPreset from "app/DealMachineCore/components/EditPreset";

import LeadOptions from "app/DealMachineCore/components/LeadOptions";
import Lists from "app/DealMachineCore/components/Lists";
import Tags from "app/DealMachineCore/components/Tags";

import CreateList from "app/DealMachineCore/components/CreateList";
import CreateTag from "app/DealMachineCore/components/CreateTag";

import DealStatuses from "app/DealMachineCore/components/DealStatuses";
import ItemSelector from "app/DealMachineCore/components/ItemSelector";

import Property from "app/DealMachineCore/components/Property";
import PropertyList from "app/DealMachineCore/components/PropertyList";
import EditInfoModal from "app/DealMachineCore/components/EditInfoModal";

import GetFeature from "app/DealMachineCore/components/GetFeature";
import InviteByEmail from "app/DealMachineCore/components/InviteByEmail";
import Logout from "app/DealMachineCore/components/Logout";

import PurchaseEngine from "app/NativeComponents/components/PurchaseEngine";
import SelectEngine from "app/NativeComponents/components/SelectEngine";

class AppRoutes extends Component {
  render() {
    if (this.props.init && this.props.user) {
      return (
        <div id="deal-main-view" className="deal-main-view">
          {/* Deal Routes */}
          <Route exact path={"/a"} component={Dashboard} />
          <Route path={"/a/dashboard"} component={Dashboard} />

          {/* purchase page */}
          <Route
            exact
            path="/a/dashboard/purchase"
            component={PurchaseEngine}
          />
          {/*plan page */}
          <Route exact path="/a/dashboard/plans" component={SelectEngine} />

          <Route
            exact
            path={"/a/dashboard/completed-sign-up"}
            component={OnboardingComplete}
          />
          <Route
            exact
            path={"/a/dashboard/activity"}
            component={AccountActivity}
          />
          <Route path={"/a/dashboard/calendar"} component={MailerCalendar} />
          <Route path={"/a/calendar"} component={MailerCalendar} />
          <Route
            exact
            path={"/a/dashboard/calendar/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={"/a/dashboard/calendar/lead-status/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            path={"/a/dashboard/activity/leads"}
            component={ActivityPropertyList}
          />
          <Route
            exact
            path={"/a/dashboard/activity/leads/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={
              "/a/dashboard/activity/leads/lead-status/onboarding-signature"
            }
            component={EditSignature}
          />
          <Route
            path={"/a/dashboard/property/:property_id"}
            component={Property}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/map-options"}
            component={PropertyMapOptions}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={
              "/a/dashboard/property/:property_id/lead-status/onboarding-signature"
            }
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/tags"}
            component={Tags}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/tags/create-tag"}
            component={CreateTag}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/lists"}
            component={Lists}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/mailing-options"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/add-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/edit-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/edit-property-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/dashboard/property/:property_id/add-owner-mailing-address"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/dashboard/property/:property_id/edit-owner-mailing-address"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/add-owner-phone-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/edit-owner-phone-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/add-owner-email-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/edit-owner-email-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/edit-note"}
            component={EditNote}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/mail-timeline"}
            component={MailTimeline}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/purchase-details"}
            component={EditDealWon}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/send-text-messages"}
            component={MultiSendNumbers}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/edit-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/create-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/add-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/select-to-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/select-from-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/dashboard/property/:property_id/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route path={"/a/map"} component={PropertyMap} />
          <Route path={"/a/map"} component={PropertyList} />
          <Route exact path={"/a/map/get-feature"} component={GetFeature} />
          <Route exact path={"/a/map/update-card"} component={CardOnFile} />
          <Route
            exact
            path={"/a/map/default-location"}
            component={DefaultLocation}
          />
          <Route exact path={"/a/map/lead-status"} component={DealStatuses} />
          <Route
            exact
            path={"/a/map/lead-status/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/map/map-options"}
            component={PropertyMapOptions}
          />
          <Route
            exact
            path={"/a/map/map-options/default-location"}
            component={DefaultLocation}
          />
          <Route
            exact
            path={"/a/map/map-options/get-feature"}
            component={PropertyMapOptions}
          />
          <Route
            exact
            path={"/a/map/map-options/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/map/map-options/add-card"}
            component={PropertyMapOptions}
          />
          <Route
            exact
            path={"/a/map/map-options/update-card"}
            component={CardOnFile}
          />
          <Route
            path={"/a/map/highlight-properties"}
            component={HighlightProperties}
          />
          <Route
            path={"/a/map/highlight-properties/preset"}
            component={EditPreset}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/preset/select-lead-status"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/preset/select-team-members"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/preset/select-tags"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/preset/select-mail-templates"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/preset/select-campaigns"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/default-location"}
            component={DefaultLocation}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/map/highlight-properties/update-card"}
            component={CardOnFile}
          />
          <Route path={"/a/map/property/:property_id"} component={Property} />
          <Route
            exact
            path={"/a/map/property/:property_id/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/default-location"}
            component={DefaultLocation}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/map-options"}
            component={PropertyMapOptions}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={
              "/a/map/property/:property_id/lead-status/onboarding-signature"
            }
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/tags"}
            component={Tags}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/tags/create-tag"}
            component={CreateTag}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/lists"}
            component={Lists}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/mailing-options"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/add-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/edit-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/edit-property-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/add-owner-mailing-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/edit-owner-mailing-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/add-owner-phone-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/edit-owner-phone-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/add-owner-email-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/edit-owner-email-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/select-to-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/select-from-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/edit-note"}
            component={EditNote}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/mail-timeline"}
            component={MailTimeline}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/purchase-details"}
            component={EditDealWon}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/send-text-messages"}
            component={MultiSendNumbers}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/edit-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/create-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/add-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/map/property/:property_id/manually-add-lead"}
            component={ManuallyAddProperty}
          />
          <Route
            exact
            path={"/a/map/manually-add-lead"}
            component={ManuallyAddProperty}
          />
          <Route path={"/a/leads/:page_id"} component={Leads} />
          <Route
            exact
            path={"/a/leads/:page_id/uploaded-list-mapping"}
            component={BulkUploadMapping}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-options"}
            component={LeadOptions}
          />
          <Route
            path={"/a/leads/:page_id/lead-filters"}
            component={LeadFilters}
          />
          <Route
            path={"/a/leads/:page_id/lead-filters/preset"}
            component={EditPreset}
          />
          <Route
            path={"/app/leads/:page_id/lead-filters/preset/lists"}
            component={Lists}
          />
          <Route
            exact
            path={"/app/leads/:page_id/lead-filters/preset/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/preset/select-lead-status"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/preset/select-team-members"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/preset/select-tags"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/preset/select-mail-templates"}
            component={ItemSelector}
          />
          <Route
            path={"/a/leads/:page_id/lead-filters/preset/lists"}
            component={Lists}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/preset/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/preset/select-campaigns"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/select-lead-status"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/select-team-members"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/select-tags"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/select-mail-templates"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/select-campaigns"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/lists"}
            component={Lists}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/tags"}
            component={Tags}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/tags/create-tag"}
            component={CreateTag}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/mailing-options"}
            component={EditInfoModal}
          />
          <Route exact path={"/a/leads/:page_id/lists"} component={Lists} />
          <Route
            exact
            path={"/a/leads/:page_id/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-status/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/leads/:page_id/send-text-messages"}
            component={MultiSendNumbers}
          />
          <Route
            exact
            path={"/a/leads/:page_id/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            exact
            path={"/a/leads/:page_id/send-text-messages/select-from-number"}
            component={EditInfoModal}
          />
          <Route exact path={"/a/leads/:page_id/tags"} component={Tags} />
          <Route
            exact
            path={"/a/leads/:page_id/tags/create-tag"}
            component={CreateTag}
          />
          <Route
            exact
            path={"/a/leads/:page_id/mailing-options"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/leads/:page_id/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/leads/:page_id/add-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/leads/:page_id/manually-add-lead"}
            component={ManuallyAddProperty}
          />
          <Route
            exact
            path={"/a/leads/:page_id/lead-filters/manually-add-lead"}
            component={ManuallyAddProperty}
          />
          <Route
            path={"/a/leads/:page_id/property/:property_id"}
            component={Property}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/get-feature"}
            component={GetFeature}
          />
          <Route
            path={"/a/leads/:page_id/property/:property_id/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/onboarding-signature"
            }
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/tags"}
            component={Tags}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/tags/create-tag"}
            component={CreateTag}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/mailing-options"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/add-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/edit-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/edit-property-address"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/add-owner-mailing-address"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/edit-owner-mailing-address"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/add-owner-phone-number"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/edit-owner-phone-number"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/add-owner-email-address"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/edit-owner-email-address"
            }
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/select-to-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/select-from-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/edit-note"}
            component={EditNote}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/mail-timeline"}
            component={MailTimeline}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/lists"}
            component={Lists}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/purchase-details"}
            component={EditDealWon}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/send-text-messages"}
            component={MultiSendNumbers}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/edit-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/create-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={
              "/a/leads/:page_id/property/:property_id/onboarding-signature"
            }
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/add-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/leads/:page_id/property/:property_id/manually-add-lead"}
            component={ManuallyAddProperty}
          />
          <Route path={"/a/property/:property_id"} component={Property} />
          <Route
            exact
            path={"/a/property/:property_id/get-feature"}
            component={GetFeature}
          />
          <Route
            path={"/a/property/:property_id/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/property/:property_id/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={"/a/property/:property_id/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/property/:property_id/tags"}
            component={Tags}
          />
          <Route
            exact
            path={"/a/property/:property_id/tags/create-tag"}
            component={CreateTag}
          />
          <Route
            exact
            path={"/a/property/:property_id/mailing-options"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/add-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/edit-owner"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/edit-property-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/add-owner-mailing-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/edit-owner-mailing-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/add-owner-phone-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/edit-owner-phone-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/add-owner-email-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/edit-owner-email-address"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/select-to-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/select-from-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            exact
            path={"/a/property/:property_id/edit-note"}
            component={EditNote}
          />
          <Route
            exact
            path={"/a/property/:property_id/mail-timeline"}
            component={MailTimeline}
          />
          <Route
            exact
            path={"/a/property/:property_id/lists"}
            component={Lists}
          />
          <Route
            exact
            path={"/a/property/:property_id/lists/create-list"}
            component={CreateList}
          />
          <Route
            exact
            path={"/a/property/:property_id/purchase-details"}
            component={EditDealWon}
          />
          <Route
            exact
            path={"/a/property/:property_id/send-text-messages"}
            component={MultiSendNumbers}
          />
          <Route
            exact
            path={"/a/property/:property_id/edit-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/create-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/property/:property_id/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/property/:property_id/add-card"}
            component={CardOnFile}
          />
          {/*
          <Route exact path={'/a/add-address'} component={ConfirmAddress}/>
          <Route exact path={'/a/add-address/manual-address'} component={ManualAddress}/>
          <Route exact path={'/a/upload-list'} component={UploadList}/>
          */}
          {/* Analytic Routes */}
          <Route
            exact
            path={"/a/dashboard/filter-analytics"}
            component={AnalyticsFilters}
          />
          <Route path={"/a/partner"} component={PartnerDashboard} />
          <Route
            exact
            path={"/a/partner/edit-paypal-email"}
            component={EditPaypalEmail}
          />
          <Route
            exact
            path={"/a/partner/edit-partner-website"}
            component={EditPartnerWebsite}
          />
          {/* Driving Routes */}
          <Route path={"/a/driving"} component={Driving} />
          <Route exact path={"/a/driving/get-feature"} component={GetFeature} />
          <Route
            exact
            path={"/a/driving/filter-analytics"}
            component={AnalyticsFilters}
          />
          <Route
            exact
            path={"/a/driving/routes/route-filters"}
            component={DrivingRouteFilters}
          />
          <Route
            exact
            path={"/a/driving/routes/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/driving/routes/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/driving/routes/route/:id"}
            component={RouteProperties}
          />
          <Route
            exact
            path={"/a/driving/routes/route/:id/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/driving/routes/route/:id/onboarding-signature"}
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/driving/routes/route/:id/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={
              "/a/driving/routes/route/:id/lead-status/onboarding-signature"
            }
            component={EditSignature}
          />
          <Route
            exact
            path={"/a/driving/routes/route/:id/route-filters"}
            component={DrivingRouteFilters}
          />
          <Route
            exact
            path={"/a/driving/drivers/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/driving/drivers/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/driving/drivers/invite"}
            component={InviteByEmail}
          />
          <Route
            exact
            path={"/a/driving/drivers/invite/:invite"}
            component={User}
          />
          <Route
            exact
            path={"/a/driving/drivers/user/:member"}
            component={User}
          />
          <Route
            exact
            path={"/a/driving/drivers/recruit-drivers"}
            component={CollectDealFinders}
          />
          <Route
            exact
            path={"/a/driving/drivers/recruit-drivers/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/driving/drivers/recruit-drivers/get-feature"}
            component={GetFeature}
          />
          {/* Driving Routes */}
          <Route path={"/a/lists"} component={ListDashboard} />
          <Route exact path={"/a/lists/get-feature"} component={GetFeature} />
          <Route path={"/a/lists/build-list"} component={BuildList} />
          <Route exact path={"/a/lists/update-card"} component={CardOnFile} />
          <Route
            exact
            path={"/a/lists/build-list/get-feature"}
            component={GetFeature}
          />
          <Route path={"/a/lists/build-list/preset"} component={EditPreset} />
          <Route
            exact
            path={"/a/lists/build-list/preset/select-lead-status"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/lists/build-list/preset/select-team-members"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/lists/build-list/preset/select-tags"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/lists/build-list/preset/select-mail-templates"}
            component={ItemSelector}
          />
          <Route
            exact
            path={"/a/lists/build-list/preset/select-campaigns"}
            component={ItemSelector}
          />
          <Route path={"/a/lists/view/:id"} component={EditList} />
          <Route
            exact
            path={"/a/lists/view/:id/get-feature"}
            component={GetFeature}
          />
          {/* Message Routes */}
          <Route path={"/a/messages"} component={MessageDashboard} />
          <Route
            exact
            path={"/a/messages/completed-sign-up"}
            component={OnboardingComplete}
          />
          <Route
            exact
            path={"/a/lists/completed-sign-up"}
            component={OnboardingComplete}
          />
          <Route
            exact
            path={"/a/crm/completed-sign-up"}
            component={OnboardingComplete}
          />
          <Route
            exact
            path={"/a/messages/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/messages/update-card"}
            component={CardOnFile}
          />
          <Route
            path={"/a/messages/conversation-settings"}
            component={ConversationSettings}
          />
          <Route
            exact
            path={"/a/messages/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            path={"/a/messages/manage-phone-numbers"}
            component={ManagePhoneNumbers}
          />
          <Route
            path={"/a/messages/manage-phone-numbers/edit-forwarding-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/messages/manage-phone-numbers/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            path={"/a/messages/manage-saved-replies"}
            component={ManageSavedReplies}
          />
          <Route
            exact
            path={"/a/messages/manage-saved-replies/edit-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/messages/manage-saved-replies/create-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            path={"/a/messages/conversation/:id"}
            component={Conversation}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/select-from-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/edit-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/create-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            path={"/a/messages/conversation/:id/lead"}
            component={ConversationLeadInfo}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/lead/add-phone-number"}
            component={PurchasePhoneNumber}
          />
          <Route
            path={"/a/messages/conversation/:id/lead/lead-status"}
            component={DealStatuses}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/lead/select-from-number"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/lead/edit-saved-reply"}
            component={EditInfoModal}
          />
          <Route
            exact
            path={"/a/messages/conversation/:id/lead/create-saved-reply"}
            component={EditInfoModal}
          />
          {/* Campaign Routes */}
          <Route exact path={"/a/campaigns"} component={Campaigns} />
          <Route
            exact
            path={"/a/campaigns/new-campaign"}
            component={EditCampaign}
          />
          <Route
            exact
            path={"/a/campaigns/edit/:id"}
            component={EditCampaign}
          />
          {/* Template Routes */}
          <Route exact path={"/a/templates"} component={Templates} />
          <Route exact path={"/a/new-template"} component={EditTemplate} />
          <Route
            exact
            path={"/a/templates/edit/:id"}
            component={EditTemplate}
          />
          {/* Signature Routes */}
          <Route exact path={"/a/signatures"} component={Signatures} />
          <Route
            exact
            path={"/a/signatures/onboarding-signature"}
            component={Signatures}
          />
          <Route
            exact
            path={"/a/signatures/onboarding-signature"}
            component={EditSignature}
          />
          <Route exact path={"/a/new-signature"} component={EditSignature} />
          <Route
            exact
            path={"/a/signatures/edit/:id"}
            component={EditSignature}
          />
          {/* Team Routes */}
          <Route path={"/a/team"} component={Team} />
          <Route exact path={"/a/team"} component={User} />
          <Route exact path={"/a/team/user/:id"} component={User} />
          <Route exact path={"/a/team/invite"} component={InviteByEmail} />
          <Route exact path={"/a/team/invite/:id"} component={User} />
          <Route
            exact
            path={"/a/onboarding/training-videos/:id"}
            component={OnboardingTrainingVideos}
          />
          <Route
            exact
            path={"/a/accept-terms-of-service/"}
            component={AcceptTerms}
          />
          <Route
            exact
            path={"/a/accept-affiliate-terms-of-service/"}
            component={AcceptAffiliateTerms}
          />
          {/* Billing Routes */}
          <Route exact path={"/a/settings"} component={Settings} />
          <Route exact path={"/a/settings/verify-email"} component={Settings} />
          <Route
            exact
            path={"/a/settings/verify-email"}
            component={VerifyEmail}
          />
          <Route exact path={"/a/settings/verify-phone"} component={Settings} />
          <Route
            exact
            path={"/a/settings/verify-phone"}
            component={VerifyPhone}
          />
          <Route
            exact
            path={"/a/settings/uploaded-list-mapping"}
            component={Settings}
          />
          <Route
            exact
            path={"/a/settings/uploaded-list-mapping"}
            component={BulkUploadMapping}
          />
          <Route exact path={"/a/settings/profile"} component={Account} />
          <Route path={"/a/settings/billing"} component={BillingDashboard} />
          <Route
            path={"/a/settings/engines-and-addons"}
            component={EnginesAndAddons}
          />

          <Route
            exact
            path={"/a/settings/engines-and-addons/billing-details"}
            component={BillingDetails}
          />
          <Route
            exact
            path={"/a/settings/engines-and-addons/get-feature"}
            component={GetFeature}
          />
          <Route
            exact
            path={"/a/settings/billing/update-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/settings/billing/add-card"}
            component={CardOnFile}
          />
          <Route
            exact
            path={"/a/settings/billing/credit-reload"}
            component={CreditReload}
          />
          <Route
            exact
            path={"/a/settings/billing/purchase-credit"}
            component={PurchaseCredits}
          />
          <Route
            exact
            path={"/a/settings/billing/invoices"}
            component={Invoices}
          />
          <Route
            exact
            path={"/a/settings/billing/sell-leads"}
            component={SellLeads}
          />
          <Route
            exact
            path={"/a/settings/billing/get-feature"}
            component={GetFeature}
          />

          <Route
            exact
            path={"/a/settings/engines-and-addons/get-feature"}
            component={GetFeature}
          />
          {/* cancel center*/}
          <Route
            exact
            path={"/a/settings/cancel/driving"}
            component={RetentionCenter}
          />
          <Route
            exact
            path={"/a/settings/cancel/lists"}
            component={RetentionCenter}
          />
          <Route
            exact
            path={"/a/settings/cancel/messages"}
            component={RetentionCenter}
          />
          {/* Settings Routes */}
          <Route
            exact
            path={"/a/settings/property-tags"}
            component={CustomPropertyTags}
          />
          <Route
            exact
            path={"/a/settings/create-tag"}
            component={CreateCustomPropertyTags}
          />
          <Route
            exact
            path={"/a/settings/mailing-options"}
            component={SendingOptions}
          />
          <Route
            exact
            path={"/a/settings/notifications"}
            component={Notifications}
          />
          <Route exact path={"/a/settings/enter-promo"} component={Promo} />
          <Route
            exact
            path={"/a/settings/training-videos"}
            component={TrainingVideos}
          />
          <Route
            exact
            path={"/a/settings/profile/user-information"}
            component={EditUserInfo}
          />
          <Route
            exact
            path={"/a/settings/profile/change-email"}
            component={EditEmail}
          />
          <Route
            exact
            path={"/a/settings/profile/change-password"}
            component={EditPassword}
          />
          <Route exact path={"/a/settings/badges"} component={Badges} />
          {/* Other Routes */}
          <Route exact path={"/a/share"} component={Share} />
          <Route path={"/a/canceled"} component={Canceled} />
          <Route path={"/a/team-removed"} component={TeamRemoved} />
          <Route path={"/a/request-to-join-team"} component={RequestTeam} />
          <Route path={"/a/requested-team"} component={RequestedTeam} />
          <Route path={"/a/logout"} component={Logout} />
        </div>
      );
    } else {
      return <Spinner />;
    }
  }
}

const mapStateToProps = ({ auth }) => {
  const { init, user, token } = auth;
  return { init, user, token };
};

export default withRouter(connect(mapStateToProps, {})(AppRoutes));
